import { createPortal } from "react-dom";
import { useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useBackgroundExportStatus } from "../../../utils/backgroundMediaExport";
import {
  BannerContainer,
  BannerContent,
  SpinnerIcon,
} from "./index.styled";

const MediaExportBanner = () => {
  const { isExporting } = useBackgroundExportStatus();
  const location = useLocation();

  const isPublicRoute = location.pathname.startsWith("/q/");
  const isLoginRoute = location.pathname === "/login";
  const isAuthCallback = location.pathname === "/auth/callback";
  const isUnauthRoute = isLoginRoute || isAuthCallback || isPublicRoute;

  const hasNav = !isUnauthRoute;

  if (!isExporting) return null;

  return createPortal(
    <BannerContainer $hasNav={hasNav} role="status" aria-live="polite">
      <SpinnerIcon>
        <Loader2 />
      </SpinnerIcon>
      <BannerContent>
        <span className="main-text">מייצר סרטון ברקע...</span>
        <span className="sub-text">אפשר להמשיך לגלוש ברגיל</span>
      </BannerContent>
    </BannerContainer>,
    document.body,
  );
};

export default MediaExportBanner;
